var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    {
      staticClass: "hidden-sm-and-down d-md-flex px-auto py-0 text-caption",
      attrs: { app: "", inset: "" }
    },
    [
      _c("span", [
        _vm._v("© " + _vm._s(_vm.year) + " - "),
        _c(
          "a",
          {
            staticClass: "text-decoration-none",
            attrs: {
              href: "http://www.tesfri.fr",
              target: "_blank",
              color: "red"
            }
          },
          [_vm._v("INNLOG")]
        )
      ]),
      _c("v-spacer"),
      _c(
        "v-btn",
        {
          attrs: {
            fab: "",
            icon: "",
            "x-small": "",
            href: "https://www.facebook.com/profile.php?id=100017383572665",
            target: "_blank"
          }
        },
        [
          _c("v-icon", { attrs: { color: "indigo" } }, [
            _vm._v("fab fa-facebook-square")
          ])
        ],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: {
            fab: "",
            icon: "",
            "x-small": "",
            href: "https://fr.linkedin.com/company/tesfri",
            target: "_blank"
          }
        },
        [
          _c("v-icon", { attrs: { color: "cyan darken-1" } }, [
            _vm._v("fab fa-linkedin")
          ])
        ],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: {
            fab: "",
            icon: "",
            "x-small": "",
            href: "https://twitter.com/TESFRI",
            target: "_blank"
          }
        },
        [
          _c("v-icon", { attrs: { color: "#00acee" } }, [
            _vm._v("fab fa-twitter-square")
          ])
        ],
        1
      ),
      _c(
        "router-link",
        { staticClass: "text-decoration-none", attrs: { to: "/Home/Privacy" } },
        [_vm._v("Politique de confidentialité")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }